const enum AdNetworkSignalSubType {
    AddedAdNetworks = "AddedAdNetworks",
    RemovedAdNetworks = "RemovedAdNetworks",
}

export default AdNetworkSignalSubType;
